// Module
var code = " <div class=\"error-icon-wrapper\"> <mat-icon class=\"full-size\" [svgIcon]=\"icon\"></mat-icon> </div> <div class=\"info\">{{ title }}</div> <div *ngIf=\"info\" class=\"error-info\">{{ info }}</div> ";
// Exports
module.exports = code;